import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';
import { InsertCategory } from '../../main/AllApi';

const POST_INSERT_CATEGORY = '/warranty/abm/api/v2/admin/options/categories/insert';

export const useInsertCategoryList = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (values) => {
      const payload = InsertCategory(values);
      const response = await POST(POST_INSERT_CATEGORY, payload);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เพิ่ม Category สำเร็จ',
      });
    },
  });
};
